import { type EventStatus, type ProgramEventStatus, isProgramEventLive } from 'models';

export const useIsLiveStatus = ({
  endTime,
  startTime,
  status,
}: {
  endTime: Date;
  startTime: Date;
  status: EventStatus | ProgramEventStatus;
}) => isProgramEventLive({ endTime, startTime }) && (status === 'published' || status === 'active');
